import { Box, createStyles, Group, Stack } from '@mantine/core';
import { Button, Text, Title } from '@repo/foundations';
import { memo } from 'react';
import { AuthCard } from '../../../components/Auth/AuthCard';
import { AuthFooter } from '../../../components/Auth/AuthLayouts/AuthFooter';

const useStyles = createStyles((theme) => ({
	video: {
		background: `url('/images/onboarding/onboarding-ai-first-frame.png') no-repeat top left  #fcfcfc`,
		backgroundSize: 'contain',
		width: 400,
		height: 520,
	},
}));

export const SecodaLiteEducationStep = memo(
	({ onNext }: { onNext: () => void }) => {
		const { classes } = useStyles();

		return (
			<AuthCard width="800px" p="0">
				<Group align="stretch" spacing="0">
					<Box className={classes.video}>
						<video
							src="https://secoda-public-media-assets.s3.us-east-1.amazonaws.com/onboarding-ai.mp4"
							autoPlay
							muted
							loop
							width={400}
							height={520}
						/>
					</Box>
					<Stack
						spacing={0}
						p="2xl"
						justify="space-between"
						style={{
							flex: 1,
						}}
					>
						<Stack spacing="3xs" h="100%" justify="center">
							<Title>Welcome to Secoda</Title>
							<Text color="text/secondary/default">
								Connect your data and get started with the AI built to give
								anyone confidence to use data.
							</Text>
						</Stack>
						<AuthFooter>
							<Group position="right" py="md" px="2xl">
								<Group spacing="xs" position="right">
									<Button variant="default" disabled>
										Back
									</Button>
									<Button onClick={onNext} variant="primary">
										Continue
									</Button>
								</Group>
							</Group>
						</AuthFooter>
					</Stack>
				</Group>
			</AuthCard>
		);
	}
);
